  $(function() {   

    $('#hero-swiper').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 3500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      fade: true,
      autoplaySpeed: 5000
      });
    
      $('#story-swiper').slick({
      dots: false,
      arrows: true,
      infinite: true,
      centerMode: true,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      fade: false,
      autoplaySpeed: 5000,
      responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: false,
      }
    }]
      });
        
        
 $('#testmonials-id').flickity({
    // options
    cellAlign: 'center',
   wrapAround: true,
    contain: true,
    initialIndex: 1,
    pageDots: false
  });
    
    
   
  $(".faq-box h5").click(function () {

  $(this).parent().toggleClass('is-active');
  $(this).next().slideToggle();
   }); 
    
 $( ".main-nav > ul" ).clone().appendTo( "#swipe-menu .mob-nav").removeAttr('id').addClass('swip-nav-ul');
$( ".top-nav > ul" ).clone().appendTo( "#swipe-menu .mob-nav").removeAttr('id').addClass('swip-nav-ul');
 
$('#swipe-menu .site-nav--dropdown').removeAttr('id');
      
 $('#swipe-menu ul.swip-nav-ul ul').slideUp(); 

         $('#swipe-menu ul.swip-nav-ul li').has('ul').addClass('has-submenu').append( '<span class="sub-toggle"></span>' );

         $('#swipe-menu ul.swip-nav-ul li span.sub-toggle').on('click', function () {
                $(this).siblings('li').find('ul').slideDown();
                $('#swipe-menu ul.swip-nav-ul ul', this).slideToggle();
            });
        
          $('.sub-toggle').on('click',function(){
                $(this).toggleClass('expanded');
                $(this).parent('li').find('> ul').slideToggle();
                $(this).parent('li').siblings('li').find('> .sub-toggle').removeClass('expanded');
                $(this).parent('li').siblings('li').find('> ul').slideUp();
            }); 
    
    
    
      

$(".ham-btn").click(function () {

  $('#swipe-menu').toggleClass('is-active');
});
$(".swipe-close").click(function () {

  $('#swipe-menu').removeClass('is-active');
});
        
    
   if($('.section-product-feature').length){    
var stickyTop = ( $(".section-product-feature").offset().top - 250);
     

$(window).on( 'scroll', function(){
        if ($(window).scrollTop() >= stickyTop) {
            $('.product-feature-dot').addClass('is-active');
        } else {
            $('.product-feature-dot').removeClass('is-active');
        }
    });   
  } 
    
$(window).on("load",function(){
				
				$(".side-menu-list").mCustomScrollbar({
					autoHideScrollbar:true,
                  theme:"dark-2",
                     scrollInertia: 400,
                  mouseWheelPixels: 70, 
					
				});
  
          $(".section-slide-notifaction").addClass("notifaction-active");
  
				
			}); 
    
    
    
   $(window).scroll(function() {    
    if ($(window).scrollTop() + $(window).height() == $(document).height()) {
        $(".section-slide-notifaction").removeClass("notifaction-active");
    } else {
        $(".section-slide-notifaction").addClass("notifaction-active");
    }
}); 
    
    $(".close-notibox").click(function () {

  $('.section-slide-notifaction').removeClass('notifaction-active').addClass("notifaction-hide");
});
    
    
     
    
  });